module.exports = __webpack_public_path__ + "static/media/1001686.1160cd10.jpg";